import React, { useRef } from "react";
import "./navbar.css";
import logoRadio from "../../imgs/logo-radio.png";

export const Navbar = () => {
  const navRef = useRef();
  const showNavbar = () => {
    navRef.current.classList.toggle("responsive-navigation");
  };
  return (
    <div className="flex justify-around w-full h-28 absolute z-10 items-center">
      <img src={logoRadio} alt="" className="w-24 h-24 animated-spawn-logo" />

      <ul className="flex items-center navigation " ref={navRef}>
        <li className="items-navigate one mx-4 text-2xl">
          <a href="#principal" className="no-underline text-gray-400 relative">
            Principal
          </a>
        </li>
        <li className="items-navigate two mx-4 text-2xl">
          <a
            href="#programacion"
            className="no-underline text-gray-400 relative"
          >
            Programación
          </a>
        </li>
        <li className="items-navigate three mx-4 text-2xl">
          <a href="#nosotros" className="no-underline text-gray-400 relative">
            Nosotros
          </a>
        </li>
        <li className="items-navigate four mx-4 text-2xl">
          <a href="#formulario" className="no-underline text-gray-400 relative">
            Contacto
          </a>
        </li>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          className="hidden close-nav"
          onClick={() => showNavbar()}
        >
          <path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" />
        </svg>
      </ul>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className="w-8 h-8 fill-orange-400 hidden hamburguer"
        onClick={() => showNavbar()}
      >
        <path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z" />
      </svg>
    </div>
  );
};
